import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function FinalClose() {
  return <section className="py-12 md:py-24 px-4 bg-[#0d0d12] border-t border-white/5 relative overflow-hidden" data-id="element-12">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#0ea5e9]/10 rounded-t-full blur-[120px] pointer-events-none" data-id="element-13" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-14">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-15">
          Tienes dos opciones ahora mismo:
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-16">
          {/* Option 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl border border-white/5 bg-[#050507] opacity-60 hover:opacity-100 transition-opacity" data-id="element-17">
            <div className="flex items-center gap-3 mb-6 text-gray-400" data-id="element-18">
              <XCircleIcon className="w-6 h-6" data-id="element-19" />
              <h3 className="text-xl font-bold" data-id="element-20">Opción 1</h3>
            </div>
            <p className="text-gray-400 leading-relaxed" data-id="element-21">
              Salir de esta página, seguir acumulando cortisol y esperar a que
              el "burnout" afecte tu salud o tu carrera de forma irreversible.
            </p>
          </motion.div>

          {/* Option 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl border border-[#0ea5e9]/30 bg-gradient-to-br from-[#0ea5e9]/10 to-transparent relative overflow-hidden" data-id="element-22">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#0ea5e9]/20 rounded-full blur-[40px]" data-id="element-23" />
            <div className="flex items-center gap-3 mb-6 text-white relative z-10" data-id="element-24">
              <CheckCircleIcon className="w-6 h-6 text-[#00d4ff]" data-id="element-25" />
              <h3 className="text-xl font-bold" data-id="element-26">Opción 2</h3>
            </div>
            <p className="text-white leading-relaxed relative z-10" data-id="element-27">
              Invertir $27 hoy y tener las herramientas definitivas para navegar
              el caos con una calma inquebrantable.
            </p>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-28">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full md:w-auto group relative inline-flex items-center justify-center px-8 md:px-12 py-5 md:py-6 text-lg md:text-xl font-bold text-white bg-gradient-to-r from-[#0ea5e9] to-[#0284c7] rounded-2xl overflow-hidden transition-all shadow-[0_0_40px_rgba(14,165,233,0.3)] hover:shadow-[0_0_60px_rgba(14,165,233,0.5)]" data-id="element-29">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-30" />
            <span className="relative flex items-center gap-3" data-id="element-31">
              SÍ, QUIERO EL PROTOCOLO DE PAUSA
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-32" />
            </span>
          </motion.button>
          <p className="mt-6 text-sm text-gray-500" data-id="element-33">
            Acceso inmediato. Pago único de $27 USD.
          </p>
        </div>
      </div>
    </section>;
}